export default "__VITE_ASSET__BCaK9BRz__"